/**
 * Models the selected chart reviews bulk edit
 */

import BulkEditFilteredModel from "./bulk-edit-filtered";
import environment from "../../common/environment";

const BulkEditSelectedModel = BulkEditFilteredModel.extend({
  urlRoot: environment.getEndpoint("chart-reviews:bulk-update-selected"),

  namedAttributes: {
    ids: [Number],
  },
});

export { BulkEditSelectedModel as default };
